import {Injectable, Optional} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Observable, switchMap} from 'rxjs';
import {LoginResponse} from 'angular-auth-oidc-client/lib/login/login-response';
import {AuthOptions} from 'angular-auth-oidc-client/lib/auth-options';
import {AuthenticatedResult} from 'angular-auth-oidc-client/lib/auth-state/auth-result';
import {AuthWellKnownEndpoints} from 'angular-auth-oidc-client/lib/config/auth-well-known/auth-well-known-endpoints';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class OidcSecurityProxyService {

    constructor(
        @Optional() private oidcSecurityService: OidcSecurityService,
        private router: Router
    ) {
    }

    checkAuth(configId?: string): Observable<LoginResponse> {
        if (window.opener) {
            window.opener = null;
        }
        return this.oidcSecurityService.checkAuth(configId);
    }

    checkAuthIncludingServer(configId?: string): Observable<LoginResponse> {
        if (window.opener) {
            window.opener = null;
        }
        return this.oidcSecurityService.checkAuthIncludingServer(configId);
    }

    revokeAccessToken(accessToken?: any, configId?: string): Observable<any> {
        return this.oidcSecurityService.revokeAccessToken(accessToken, configId);
    }

    logoffLocal(configId?: string): void {
        this.oidcSecurityService.logoffLocal(configId);
    }

    getAccessToken(configId?: string): Observable<string> {
        return this.oidcSecurityService.getAccessToken(configId);
    }

    authorize(configId?: string, authOptions?: AuthOptions): void {
        if (!authOptions) {
            const customParams = {};
            const returnUrl = this.router.routerState.snapshot.root.queryParams['returnUrl'];
            if (returnUrl) {
                customParams['resource'] = returnUrl;
            }
            authOptions = {
                customParams: customParams,
                urlHandler: (url) => {
                    // ToDo: add support of lastVisitedPage / returnUrl params
                    window.location.href = url.replace('/account/authorize', '/account/default/authorize');
                }
            };
        }
        this.oidcSecurityService.authorize(configId, authOptions);
    }

    getIsAuthenticated$(): Observable<AuthenticatedResult> {
        return this.oidcSecurityService.isAuthenticated$;
    }

    getUserData(): Observable<any> {
        return this.oidcSecurityService.getUserData();
    }

    forceRefreshSession(): Observable<any> {
        return this.oidcSecurityService.forceRefreshSession();
    }

    refreshSession(): Observable<any> {
        return this.oidcSecurityService.forceRefreshSession().pipe(
            switchMap((loginResponse: any) => this.checkAuth())
        );
    }

    preloadAuthWellKnownDocument(configId?: string): Observable<AuthWellKnownEndpoints> {
        return this.oidcSecurityService.preloadAuthWellKnownDocument(configId);
    }

    getPayloadFromAccessToken(encode?: boolean, configId?: string): Observable<any> {
        return this.oidcSecurityService.getPayloadFromAccessToken(encode, configId);
    }
}
